import { Box, styled } from '@mui/material';

export const StyledNamesColumnWrapper = styled(Box)(({ theme }) => ({}));
